/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      document.querySelector('.cart__drawer__title .cart-count').textContent = cart.item_count;
      // ... update an app or a custom shipping caluclator
    }
    if(cart.item_count == 0) {
      document.querySelector('.cart__drawer').classList.add('cart--empty');
      document.querySelector('.cart__drawer__title .cart-count-wrapper').classList.add('hide');
    } else {
      document.querySelector('.cart__drawer').classList.remove('cart--empty');
      document.querySelector('.cart__drawer__title .cart-count-wrapper').classList.remove('hide');
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });


  document.querySelector('[name="attributes[gift-wrapping]"]').addEventListener("change", function(event) {
      if (event.target.checked) {
        let formData = {
 'items': [{
  'id': 21191511113846,
  'quantity': 1
  }]
};

fetch(window.Shopify.routes.root + 'cart/add.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify(formData)
})
.then(response => {
  document.dispatchEvent(
              new CustomEvent('theme:cart:change', {
                detail: {
                  cart: response.data,
                },
                bubbles: true,
              }));
      return response.json();
})
.then(data => {
      document.dispatchEvent(new CustomEvent('theme:cart:reload', {bubbles: true}));
      document.querySelector('[data-drawer="drawer-cart"]').dispatchEvent(new CustomEvent('theme:drawer:open', {bubbles: true}));  
    })
.catch((error) => {
  console.error('Error:', error);
});
        document.querySelector('#is-a-gift input').setAttribute("checked", "checked");
      } else {
        document.querySelector('#is-a-gift input').value = 'no';
        document.querySelector('#is-a-gift input').removeAttribute("checked");
        let updates = {
            21191511113846: 0
          };

          fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ updates })
          })
          .then(response => {
            document.dispatchEvent(
              new CustomEvent('theme:cart:change', {
                detail: {
                  cart: response.data,
                },
                bubbles: true,
              }));
      return response.json();
          })
          .then(data => {
      document.dispatchEvent(new CustomEvent('theme:cart:reload', {bubbles: true}));
      document.querySelector('[data-drawer="drawer-cart"]').dispatchEvent(new CustomEvent('theme:drawer:open', {bubbles: true}));  
    })
          .catch((error) => {
            console.error('Error:', error);
          });
        }

    });

    document.addEventListener('theme:popdown:search', (e) => {
    var query_list = document.querySelectorAll('.search__predictive__suggestions-list li');
    query_list.forEach(function(item) {
      item.addEventListener('click', function(e) {
        var input_element = item.parentElement.parentElement.parentElement.parentElement;
        input_element.querySelector('.search-input').value = item.innerHTML;
        input_element.querySelector('.search-input').focus();
      });
    });
    document.querySelectorAll('.search__predictive__filters div').forEach(function(item) {
      item.addEventListener('click', function(e) {
        var input_element = item.parentElement.parentElement.parentElement.parentElement;
        var filter_name = this.innerHTML.replace(/\s/g, '');
        input_element.querySelector('.search-input').value += ' ' + filter_name;
        input_element.querySelector('.search-input').focus();
      });
    });
    document.querySelector('.search__predictive__clear button').addEventListener('click', function(e) {
      document.querySelector('.search-popdown').classList.remove('visible-filters');
    });
  });

  document.addEventListener('theme:search:performed', function(event) {
    var searchTerm = event.detail.search;
    searchTerm = searchTerm.toLowerCase();
    if(searchTerm == 'linen' || searchTerm == 'swim') {
      document.querySelector('.search-popdown').classList.add('visible-filters');
    }
    else {
      document.querySelector('.search-popdown').classList.remove('visible-filters');
    }
  });

  document.addEventListener('theme:search:performedcache', function(event) {
    var searchTerm = event.detail.search;
    searchTerm = searchTerm.toLowerCase();
    if(searchTerm == 'linen' ) {
      document.querySelector('.search-popdown').classList.add('visible-filters');
    }
    else {
      document.querySelector('.search-popdown').classList.remove('visible-filters');
    }
  });

  document.addEventListener('theme:quickview:media', function(event) {
    //if(document.querySelector('.search-popdown').classList.contains('is-visible')) {
      //document.querySelector('.search-popdown').classList.remove('is-visible');
      //document.querySelector('.drawer__underlay').classList.remove('underlay--visible');
    //}
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

   function mobile_carousel() {
      let mobile_carousel_selector = document.querySelectorAll('.product-grid-item__images');
      mobile_carousel_selector.forEach(function(item) {
        var flkty = new Flickity( item, {
              autoPlay: false,
              prevNextButtons: false,
              pageDots: true,
              adaptiveHeight: false,
              accessibility: true,
              setGallerySize: true,
              cellAlign: 'left',
              wrapAround: true,
              groupCells: true,
              });
        flkty.on("change", function() {
              flkty.cells.forEach(function(cell, i) {
                if (cell.element == flkty.selectedElement) {
                  flkty.selectedElement.setAttribute('loading', 'eager');
                }
              });
            });
      });
    }

  if(document.querySelector('body').classList.contains('template-product')) {
    var men_sizing_tab = document.querySelector('.men-sizing-tab');
    men_sizing_tab.addEventListener('click', function(e) {
      document.querySelector('.men-sizing-chart').classList.add('active');
      document.querySelector('.men-sizing-tab').classList.add('active');
      if(document.querySelector('.women-sizing-chart').classList.contains('active')) {
        document.querySelector('.women-sizing-chart').classList.remove('active');
        document.querySelector('.women-sizing-tab').classList.remove('active');
      }
    });
    var women_sizing_tab = document.querySelector('.women-sizing-tab');
    women_sizing_tab.addEventListener('click', function(e) {
      document.querySelector('.women-sizing-chart').classList.add('active');
      document.querySelector('.women-sizing-tab').classList.add('active');
      if(document.querySelector('.men-sizing-chart').classList.contains('active')) {
        document.querySelector('.men-sizing-chart').classList.remove('active');
        document.querySelector('.men-sizing-tab').classList.remove('active');
      }
    });
  }

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
